import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ManageTestimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState(null); // For pagination if needed
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch testimonials from the server
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(
          "https://your-api-url.com/website/testimonial"
        );
        const data = await response.json();
        setTestimonials(data.testimonials); // Assuming the response has a 'testimonials' key
        setLinks(data.links); // If pagination is used
        setLoading(false);
      } catch (err) {
        setError("Failed to load testimonials");
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const handleDelete = async (id) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-danger",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (confirmed.isConfirmed) {
      try {
        await fetch(
          `https://your-api-url.com/website/testimonial/delete/${id}`,
          {
            method: "DELETE",
          }
        );
        Swal.fire("Deleted!", "The testimonial has been deleted.", "success");
        setTestimonials(
          testimonials.filter((testimonial) => testimonial.id !== id)
        );
      } catch (error) {
        Swal.fire(
          "Error!",
          "There was an issue deleting the testimonial.",
          "error"
        );
      }
    }
  };

  const handleAddTestimonial = () => {
    navigate("/website/testimonial/add"); // Redirect to Add Testimonial page
  };

  return (
    <div className="page-container mt-5">
      <div className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <h4 className="panel-title pull-left">Manage Testimonial</h4>
            <button
              className="btn btn-default btn-sm pull-right"
              onClick={handleAddTestimonial}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Testimonial
            </button>
          </div>
          {loading ? (
            <p>Loading testimonials...</p>
          ) : error ? (
            <p>{error}</p>
          ) : testimonials.length === 0 ? (
            <p>
              No testimonials found.{" "}
              <Link to="/website/testimonial/add">Add one</Link>.
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table m-b-0">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>#</th>
                    <th>Description</th>
                    <th>Review By</th>
                    <th style={{ width: "1%" }} colSpan="2">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {testimonials.map((testimonial, index) => (
                    <tr key={testimonial.id}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {index + 1}
                      </td>
                      <td>{testimonial.description}</td>
                      <td>{testimonial.reviewby}</td>
                      <td>
                        <Link
                          to={`/website/testimonial/edit/${testimonial.id}`}
                          className="btn btn-warning btn-xs"
                        >
                          <FontAwesomeIcon icon={faPencil} />{" "}
                        </Link>
                      </td>
                      <td>
                        <button
                          onClick={() => handleDelete(testimonial.id)}
                          className="btn btn-danger btn-xs"
                        >
                          <FontAwesomeIcon icon={faTrash} />{" "}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {links && <div>{links}</div>} {/* Pagination links */}
        </div>
      </div>

      {/* Modal for displaying more information (Optional) */}
      <div id="myModal" className="modal">
        <div className="modal-dialog panel panel-default panel-border top">
          <div className="modal-content">
            <div id="myModalContent"></div>
          </div>
        </div>
      </div>

      {/* Scroll to top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default ManageTestimonial;
